import './Tracker.css';
import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
function Tracker(){
    const [rows, setRows] = useState([]);

    const addRow = () => {
        setRows([...rows, { date: '', category: '', description: '', amount: '' }]);
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const newRows = [...rows];
        newRows[index][name] = value;
        setRows(newRows);
    };

    const calculateTotalAmount = () => {
        return rows.reduce((total, row) => {
          return total + (parseFloat(row.amount) || 0);
        }, 0);
    };

    const getHighestAmountItem = () => {
        if (rows.length === 0) return null;
        return rows.reduce((max, row) => {
          return parseFloat(row.amount) > parseFloat(max.amount) ? row : max;
        }, rows[0]);
      };
    
      const getTopCategories = () => {
        const categoryTotals = rows.reduce((acc, row) => {
          const amount = parseFloat(row.amount) || 0;
          if (row.category) {
            acc[row.category] = (acc[row.category] || 0) + amount;
          }
          return acc;
        }, {});
    
        const sortedCategories = Object.entries(categoryTotals).sort((a, b) => b[1] - a[1]);
        return sortedCategories.slice(0, 3);
      };
    
      const highestAmountItem = getHighestAmountItem();
      const topCategories = getTopCategories();


    //   Screenshot

    const captureScreenshot = async () => {
        const element = document.body; // Capture the entire page
    
        // Capture the screenshot of the entire page
        const canvas = await html2canvas(element, {
          scrollY: 0, // Start from the top of the page
          windowWidth: document.documentElement.scrollWidth,
          windowHeight: document.documentElement.scrollHeight,
        });
    
        // Convert the canvas to an image
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
    
        // Create a download link
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'screenshot.jpg';
    
        // Append the link to the document and trigger the download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };


    // Expense title 

    const [expenseTitle, setExpenseTitle] = useState('');

    const handleTitleChange = (event) => {
        setExpenseTitle(event.target.value);
    };

    return(
        <div className='bg-color d-flex justify-content-center align-items-center'>
            <div className='inner-bg d-flex flex-column justify-content-between'>
                <div className='tracker-heading text-center py-4'>
                    <input
                        className='py-1 px-2'
                        type="text" 
                        placeholder="Enter Expense Title" 
                        value={expenseTitle} 
                        onChange={handleTitleChange} 
                    />
                </div>
                <div className='tracker-part row main-row'>
                    <div className='col-3 left-border'>
                        <h5 className='manrope-myfont'>Date</h5>
                    </div>
                    <div className='col-3'>
                        <h5 className='manrope-myfont'>Category</h5>
                    </div>
                    <div className='col-3'>
                        <h5 className='manrope-myfont'>Description</h5>
                    </div>
                    <div className='col-3 right-border'>
                        <h5 className='manrope-myfont'>Amount</h5>
                    </div>
                </div>

                <div className='items pb-2 pt-4'>
                    {rows.map((row, index) => (
                        <div className="row items-row mb-3" key={index}>
                            <div className="col p-0">
                                <input
                                type="date"
                                className="form-control"
                                name="date"
                                value={row.date}
                                onChange={(event) => handleInputChange(index, event)}
                                />
                            </div>
                            <div className="col p-0">
                                <input
                                type="text"
                                className="form-control"
                                placeholder="Category"
                                name="category"
                                value={row.category}
                                onChange={(event) => handleInputChange(index, event)}
                                />
                            </div>
                            <div className="col p-0">
                                <input
                                type="text"
                                className="form-control"
                                placeholder="Description"
                                name="description"
                                value={row.description}
                                onChange={(event) => handleInputChange(index, event)}
                                />
                            </div>
                            <div className="col p-0">
                                <input
                                type="number"
                                className="form-control"
                                placeholder="Amount"
                                name="amount"
                                value={row.amount}
                                onChange={(event) => handleInputChange(index, event)}
                                />
                            </div>
                        </div>
                    ))}
                </div>
                
                <div className='d-flex btn-div row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                        <button className="btn btn-primary add-button mb-3 manrope-myfont" onClick={addRow}>Add<span><i className="btn-icon fa-solid fa-plus"></i></span></button>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                        <button className="btn btn-warning add-button mb-3 manrope-myfont" onClick={captureScreenshot}>Take Screenshot<span><i className="btn-icon fa-solid fa-photo-film"></i></span></button>
                    </div>
                    
                </div>
                

                <div className='final p-2 py-3 row'>
                    <div className='col-6'>
                    </div>
                    <div className='col-3 text-end total-text'>
                        <h5 className='manrope-myfont'>Total Amount: </h5>
                    </div>
                    <div className='final-text col-3'>
                        <h5 className='manrope-myfont'>${calculateTotalAmount().toFixed(2)}</h5>
                    </div>
                </div>

                {/* Highest price part */}

                {highestAmountItem && (
                    <div className="highest-amount mt-3">
                    <h5 className='manrope-myfont'>Highest Amount Item: {highestAmountItem.description} - ${parseFloat(highestAmountItem.amount).toFixed(2)}</h5>
                    </div>
                )}
                {topCategories.length > 0 && (
                    <div className="top-categories mt-3 ">
                    <h5 className='pb-2 manrope-myfont'>Top 3 Categories by Amount:</h5>
                    <ul>
                        {topCategories.map(([category, total], index) => (
                        <li className="manrope-myfont" key={index}>{category}: ${total.toFixed(2)}</li>
                        ))}
                    </ul>
                    </div>
                )}
                <h5 className='pt-5 text-center manrope-myfont made-text'>Made by: Abdul Wahab</h5>
                
            </div>
        </div>
    )
}

export default Tracker;